@use "@inshared/ui-foundation/css/tokens/typography/font-family";
@use "@inshared/ui-foundation/css/tokens/color";
@use "@inshared/ui-foundation/css/tokens/typography/font-size";
@use "@inshared/ui-foundation/css/tokens/spacing";
@use "@inshared/ui-foundation/css/tokens/size";
@use "@inshared/ui-foundation/css/tokens/border-width";
@use "@inshared/ui-foundation/css/tokens/border-radius";
@use "@inshared/ui-foundation/css/tokens/breakpoints";

:host,
.web-list {
    --web-list-icon-start-size: #{size.$icon-md};
    --web-list-icon-end-size: #{size.$icon-md};
    --web-list-icon-color: #{color.$color-primary};
    --web-list-icon-gap: #{spacing.$md};

    --web-list-border-color: #{color.$color-border-light};
    --web-list-padding-block: #{spacing.$md-lg};
    --web-list-column-gap: #{spacing.$xl};
    --web-list-border-width: #{border-width.$sm};

    --web-list-number-font: #{font-family.$handwritten};
    --web-list-number-size: #{font-size.$xxl};

    --web-list-columns: 1;

    ul {
        column-gap: var(--web-list-column-gap);
        margin: 0;
        padding-left: 0;
        width: 100%;
        list-style-type: none;
    }

    li {
        border-bottom: 0 solid var(--web-list-border-color);
        break-inside: avoid-column;

        &:not(:has(a)),
        a {
            display: grid;
            grid-auto-flow: column;
            gap: var(--web-list-icon-gap);
            padding-block: var(--web-list-padding-block);
            align-items: center;

            &:has(.icon-start) {
                // max-content with no icon breaks word wrapping
                grid-template-columns: max-content;
            }
        }

        web-icon {
            color: var(--web-list-icon-color);

            &.icon-start {
                --icon-width: var(--web-list-icon-start-size);
                --icon-height: var(--web-list-icon-start-size);
            }

            &.icon-end {
                --icon-width: var(--web-list-icon-end-size);
                --icon-height: var(--web-list-icon-end-size);
                justify-self: end;
            }
        }
    }

    // predefined alternate styles
    &.stroked li {
        border-bottom-width: var(--web-list-border-width);
    }

    &.vertical ul {
        @media (min-width: breakpoints.$screen-lg-min) {
            column-count: var(--web-list-columns);
        }
    }

    &.horizontal ul {
        --web-list-column-gap: #{spacing.$xxl};
        --web-list-padding-block: #{spacing.$md};

        display: flex;
        flex-direction: column;
        justify-content: center;
        flex-wrap: wrap;

        @media (min-width: breakpoints.$screen-mobile-max) {
            flex-direction: row;
        }
    }

    &.button-bar ul {
        --web-list-icon-start-size: 40px;

        display: grid;
        grid-auto-flow: row;
        gap: spacing.$lg;

        @media (min-width: breakpoints.$screen-lg-min) {
            grid-template-columns: repeat(var(--web-list-columns), 1fr);
        }

        li a {
            padding: spacing.$xxl spacing.$xl;
            background: color.$color-light;
            border-radius: border-radius.$lg-xl;
            height: 100%;
        }
    }

    &.button-grid ul {
        --web-list-icon-start-size: 75px;

        display: grid;
        gap: spacing.$lg;
        grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));

        @media (min-width: breakpoints.$screen-lg-min) {
            grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
        }

        li a {
            grid-auto-flow: row;
            grid-template-columns: auto;
            justify-content: center;
            justify-items: center;
            text-align: center;
        }
    }

    &.numbered ul {
        counter-reset: list-counter;

        li:not(:has(a)),
        li a {
            position: relative;
            &::before {
                display: inline-block;
                margin-inline-end: spacing.$md;
                min-width: size.$lg;
                color: var(--web-list-icon-color);
                font-family: var(--web-list-number-font);
                font-size: var(--web-list-number-size);
                content: counter(list-counter) ".";
                counter-increment: list-counter;
            }
        }

        web-icon.icon-start {
            display: none;
        }
    }
}
